import {Button, Dialog, DialogContent, Typography} from "@mui/material";
import React, {useState} from "react";
import {useSessionContext} from "../../util/SessionContext";
import {personaOptions} from "../../util/ssoAuthenticate";
import PersonaSelect from "./PersonaSelect";
import css_shared from "./css/LoginCommon.module.scss";
import css_nav from "../Navigation/css/NavBar.module.scss";
import css_buttons from "../Common/css/CCButton.module.scss";
import parkourImage from "../../assets/ParkourLogo.svg";
import {Blue3} from "../../theme/styles";

// Shown after an SSO hand-off when the signed-in user has more than one persona. The source app
// (e.g. Developer) can't direct a persona, so the user must choose one here before the app renders.
// Renders the same grouped PersonaSelect dropdown the login screen uses, fed from the established
// session's Account. On confirm it sets the active visibility and calls onSelected() to release the app.
export default function SelectPersonaDialog({onSelected}: {onSelected: () => void}) {
    const sessionContext = useSessionContext();
    const account = sessionContext.getAccount();
    const options = personaOptions(account);

    // Default to the same first persona the login flow would default to (Position → UserGroup → WorkGroup).
    const [selected, setSelected] = useState<string>(
        options.length > 0 ? `${options[0].mode}:${options[0].value}` : "",
    );

    function confirm() {
        if (!selected) return;
        const separator = selected.indexOf(":");
        const mode = selected.slice(0, separator);
        const value = selected.slice(separator + 1);
        sessionContext.setActiveVisibility(mode, value);
        onSelected();
    }

    return (
        <Dialog maxWidth="md" open={true} scroll="body">
            <DialogContent style={{padding: "0 16px", minWidth: "360px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                    <div key={1} style={{paddingTop: "0px", paddingRight: "2px", marginLeft: "-5px"}}><img className={css_nav.ParkourLogo} src={parkourImage} alt="Home"/></div>
                    <div key={2} style={{paddingTop: "5px", marginLeft: "57px", marginRight: "4px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>|</Typography></div>
                    <div key={3} style={{paddingTop: "7px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>&nbsp;&nbsp;ParkourAI</Typography></div>
                </div>
                <Typography className={css_shared.Title}>Select your persona</Typography>
                <PersonaSelect
                    positions={account?.["Positions"] ?? []}
                    positionAncestors={account?.["PositionAncestors"] ?? []}
                    userGroups={account?.["UserGroups"] ?? []}
                    workGroups={account?.["WorkGroups"] ?? []}
                    value={selected}
                    onChange={setSelected}/>
                <Button
                    className={css_buttons.blueStandardButton}
                    style={{width: "100%", marginTop: "20px", marginBottom: "5px"}}
                    disabled={!selected}
                    onClick={confirm}
                >
                    Continue
                </Button>
                <div style={{height: "10px"}}/>
            </DialogContent>
        </Dialog>
    );
}
